import React, { useState } from "react";
import "../css/delivery.scss";

function Delivery() {
  const [expandedSection, setExpandedSection] = useState(null);

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  return (
    <div className="wrapper--narrow section-padding">
      <div className="text__standard" data-accordion-group="">
        <p className="standard__kicker text-left accent-size-4">SHIPPING</p>

        <div className="accordion__wrapper">
          <button
            className="accordion__title"
            onClick={() => toggleSection("processing")}
          >
            Order Processing Times
            <svg
              className={`accordion-icon ${
                expandedSection === "processing" ? "expanded" : ""
              }`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          {expandedSection === "processing" && (
            <div className="accordion__body rte body-size-4">
              <p>
                Orders will generally be packed and shipped within 2-3 business
                days, but may sometimes take up to 5-7 business days, depending
                on product availability. If you would like to ship via expedited
                delivery service, please be sure to check with us to confirm the
                estimated delivery date before placing your order.
              </p>
            </div>
          )}
        </div>

        <div className="accordion__wrapper">
          <button
            className="accordion__title"
            onClick={() => toggleSection("us")}
          >
            US Delivery
            <svg
              className={`accordion-icon ${
                expandedSection === "us" ? "expanded" : ""
              }`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          {expandedSection === "us" && (
            <div className="accordion__body rte body-size-4">
              <p>
                Sacuddin ships all orders via DHL.&nbsp;&nbsp;
                <em>
                  We offer free US Standard Ground shipping for orders over
                  $300.
                </em>
              </p>
              <ul>
                <li>
                  Standard Ground&nbsp; &nbsp; &nbsp;&nbsp;5-7&nbsp; business
                  days&nbsp; &nbsp; &nbsp; &nbsp;$15
                </li>
                <li>
                  Expedited&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                  &nbsp; &nbsp;2 to 4 business days&nbsp; &nbsp;&nbsp;&nbsp;$25
                </li>
                <li>
                  Next Day&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                  &nbsp; &nbsp;1 business day&nbsp;&nbsp; &nbsp; &nbsp; &nbsp;
                  &nbsp; &nbsp; &nbsp; $35
                </li>
              </ul>
              <p>
                <em>
                  Please note the above times does not include processing times.
                </em>
              </p>
            </div>
          )}
        </div>

        <div className="accordion__wrapper">
          <button
            className="accordion__title"
            onClick={() => toggleSection("international")}
          >
            International Delivery
            <svg
              className={`accordion-icon ${
                expandedSection === "international" ? "expanded" : ""
              }`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          {expandedSection === "international" && (
            <div className="accordion__body rte body-size-4">
              <ul>
                <li>
                  Worldwide Express&nbsp; &nbsp; &nbsp; &nbsp; 5-7 business
                  days&nbsp; &nbsp; &nbsp;&nbsp;$100
                </li>
              </ul>
            </div>
          )}
        </div>

        <div className="accordion__wrapper">
          <button
            className="accordion__title"
            onClick={() => toggleSection("lost")}
          >
            Lost or Stolen Packages
            <svg
              className={`accordion-icon ${
                expandedSection === "lost" ? "expanded" : ""
              }`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          {expandedSection === "lost" && (
            <div className="accordion__body rte body-size-4">
              <p>
                We know carrier issues and delays can happen, if you have not
                received your order by the 3rd business day after it has been
                scanned as "Delivered," please contact Customer Service for
                assistance. We find that carriers may scan a package as
                “Delivered” when it is still out for delivery and will deliver
                within the next three business days. If after 3 business days,
                you have still not located your delivery, and you have checked
                the surrounding delivery address, Customer Service will
                coordinate the refund of your order to original payment method
                for re-ordering.&nbsp;
              </p>
              <p>
                <em>
                  Note:&nbsp;Sacuddin is not currently set up for reshipment
                  orders or exchanges and requires that a new order is placed
                  with the returned funds.
                </em>
                If the carrier’s tracking link for your order is not showing
                activity or movement for more than 5 business days, please
                contact Customer Service to investigate.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Delivery;
